import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import FormText from './FormText.js';
import FormTime from './FormTime.js';
import FormScan from './FormScan.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function CalendarNew({usrInfo, showNew, closeNew, newDT, updateCalendarRowNew, sharedUsers, onSharedUsersChange}) {
	const popupAnimationMs = 300;
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState('');
	const [repeat, setRepeat] = useState(0);
	const [nameError, setNameError] = useState('');
	const [days, setDays] = useState(1);
	const [daysError, setDaysError] = useState('');
	const [repeatCnt, setRepeatCnt] = useState(1);
	const [repeatCntError, setRepeatCntError] = useState('');
	const [parentPromoCode, setParentPromoCode] = useState('');
	const [parentPromoCodeError, setParentPromoCodeError] = useState('');
	const [sharedUsersState, setSharedUsersState] = useState([]);
	const [sharedUsersStateChck, setSharedUsersStateChck] = useState({});
	const [timeEvent, setTimeEvent] = useState('00:00');
	const [timeEventEnd, setTimeEventEnd] = useState('23:59');
	const [timeEventError, setTimeEventError] = useState('');
	const [timeEventEndError, setTimeEventEndError] = useState('');
	const timeEventRef = useRef(null);
	const timeEventEndRef = useRef(null);

	const nameRef = useRef(null);
	const daysRef = useRef(null);
	const repeatCntRef = useRef(null);
	const parentPromoCodeRef = useRef(null);
	const wasOpenRef = useRef(false);
	const {shouldRender, isClosing} = usePopupAnimation(showNew, popupAnimationMs);

	useEffect(() => {
		if (showNew && !wasOpenRef.current) {
			setName('');
			setNameError('');
			setRepeat(0);
			setDays(1);
			setDaysError('');
			setRepeatCnt(1);
			setRepeatCntError('');
			setParentPromoCode('');
			setParentPromoCodeError('');
			setTimeEvent('00:00');
			setTimeEventEnd('23:59');
			setTimeEventEndError('');
			setTimeEventError('');

			setSharedUsersState(Array.isArray(sharedUsers) ? sharedUsers : []);
			setSharedUsersStateChck({});
		}

		wasOpenRef.current = showNew;
	}, [showNew, sharedUsers]);

	const setRep = (e, val) => {
		e.preventDefault();
		setRepeat(val);
	}

	const handleSubmit = (e) => {
		e.preventDefault();

		setNameError('');
		setDaysError('');
		setRepeatCntError('');
		setParentPromoCodeError('');
		setTimeEventError('');
		setTimeEventEndError('');
		let localError = 0;

		if (!name) {
			localError = 1;
			setNameError('povinné');
			nameRef.current.focus();
		}

		if (!days) {
			localError = 1;
			setDaysError('povinné');
			daysRef.current.focus();
		}

		if (localError === 0) {
			setLoading(true);

			post('saveCalendarNew', {STARTDT: newDT, NAME: name, REPEATID: repeat, REPEATID_CNT: repeatCnt, DAYS: days, sharedUsers: sharedUsersStateChck, timeEvent: timeEvent, timeEventEnd: timeEventEnd})
				.then((res) => {
					closeNew();
					updateCalendarRowNew();
					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const formattedNewDT = (() => {
		if (typeof newDT !== 'string') {
			return newDT;
		}

		const parts = newDT.split('-');

		if (parts.length !== 3) {
			return newDT;
		}

		const [year, month, day] = parts;

		return `${parseInt(day, 10)}.${parseInt(month, 10)}.${year}`;
	})();

	const handleVerifyPromo = (e) => {
		e.preventDefault();

		setParentPromoCodeError('');

		if (parentPromoCode !== '') {
			if (parentPromoCode !== usrInfo.myPromoCode) {
				setLoading(true);

				post('verifyPromoCode', {parentPromoCode})
					.then((res) => {
						if (res.data.result === -1) {
							setParentPromoCodeError('Došlo k neznámé chybě. Zkuste to později.');
						} else if (res.data.result === 0) {
							setParentPromoCodeError('Neplatná pozvánka.');
						} else if (res.data.result === 1) {
							setParentPromoCodeError(res.data.resultTxt);
						}

						setLoading(false);
					})
					.catch((error) => {
						console.error(error);
						setLoading(false);
					});
			} else {
				setParentPromoCodeError('Neplatná pozvánka.');
				parentPromoCodeRef.current.focus();
			}
		} else {
			setParentPromoCodeError('Zadejte pozvánku.');
			parentPromoCodeRef.current.focus();
		}
	}

	const addPromo = (e) => {
		e.preventDefault();

		setParentPromoCodeError('');

		if (parentPromoCode !== '') {
			setLoading(true);

			post('addPromoCodeToCalendar', {parentPromoCode})
				.then((res) => {
					if (res.success) {
						setParentPromoCode('');
						
						const nextSharedUsers = Array.isArray(res.data) ? res.data : [];

						setSharedUsersState(nextSharedUsers);
						setSharedUsersStateChck((prevState) => {
							const nextState = {...prevState};

							for (const user of nextSharedUsers) {
								if (nextState[user.SHAREWITH_USRID] === undefined) {
									nextState[user.SHAREWITH_USRID] = 0;
								}
							}

							return nextState;
						});

						if (onSharedUsersChange) {
							onSharedUsersChange(nextSharedUsers);
						}
					} else {
						setParentPromoCodeError('Došlo k neznámé chybě. Zkuste to později.');
					}

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		} else {
			setParentPromoCodeError('Zadejte pozvánku.');
			parentPromoCodeRef.current.focus();
		}
	}

	const setUsrShare = (e, usrId) => {
		e.preventDefault();

		const isCurrentlyShared = sharedUsersStateChck[usrId];

		setSharedUsersStateChck((prevState) => ({
			...prevState,
			[usrId]: isCurrentlyShared === 0 || isCurrentlyShared === undefined ? 1 : 0,
		}));
	}

	return (
		<>
			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Nová událost - {formattedNewDT}</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeNew();
									}}
								/>
							</div>
							<div className="popup_content_in_body">
								<div className="popup_content_in_body_in">
									<div className="fl_l" style={{width: '48%'}}>
										<FormTime label="Čas od" maxLength="5" readOnly value={timeEvent} setValue={setTimeEvent} ref={timeEventRef} error={timeEventError} useCurrentTime={false} />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										<FormTime label="Čas do" maxLength="5" readOnly value={timeEventEnd} setValue={setTimeEventEnd} ref={timeEventEndRef} error={timeEventEndError} useCurrentTime={false} />
									</div>
									<div className="zero h0" />

									<FormText type="text" label="Událost" value={name} setValue={setName} ref={nameRef} error={nameError} />

									<div className="fl_l" style={{width: '48%'}}>
										<FormText type="text" label="Trvání dnů" value={days} setValue={setDays} ref={daysRef} error={daysError} />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										{repeat > 0 && <FormText type="text" label="Interval opakování" value={repeatCnt} setValue={setRepeatCnt} ref={repeatCntRef} error={repeatCntError} />}
									</div>
									<div className="zero h0" />

									<span className="fl_l"><b>Opakování</b></span>
									<div className="zero h1" />

									<div className="fl_l" style={{width: '48%'}}>
										<div className="fl_l mr_2 cr_p" onClick={(e) => setRep(e, 0)}>
											<button type="button" className={`button check ${parseInt(repeat) === 0 ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
											<span className="fl_l mt_02">Žádné</span>
										</div>
										<div className="zero h1" />

										<div className="fl_l mr_2 cr_p" onClick={(e) => setRep(e, 1)}>
											<button type="button" className={`button check ${parseInt(repeat) === 1 ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
											<span className="fl_l mt_02">Týdenní</span>
										</div>
										<div className="zero h1" />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										<div className="fl_l mr_2 cr_p" onClick={(e) => setRep(e, 2)}>
											<button type="button" className={`button check ${parseInt(repeat) === 2 ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
											<span className="fl_l mt_02">Měsíční</span>
										</div>
										<div className="zero h1" />

										<div className="fl_l mr_2 cr_p" onClick={(e) => setRep(e, 3)}>
											<button type="button" className={`button check ${parseInt(repeat) === 3 ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
											<span className="fl_l mt_02">Roční</span>
										</div>
									</div>
									<div className="zero h2" />

									<span className="fl_l"><b>Sdílení</b></span>
									<div className="zero h1" />

									<div className="fl_l" style={{width: '48%'}}>
										<FormScan type="text" label="Pozvánka" value={parentPromoCode} setValue={setParentPromoCode} ref={parentPromoCodeRef} error={parentPromoCodeError} />	
									</div>
									<div className="fl_r txt_r" style={{width: '48%'}}>
										<input type="button" name="button_login" value="Přidat" className="button fl_r mt_18 ml_05" disabled={loading} onClick={addPromo} />
										<input type="button" name="button_login" value="Ověřit" className="button fl_r mt_18" disabled={loading} onClick={handleVerifyPromo} />
									</div>
									<div className="zero h1" />

									{sharedUsersState.length > 0 && (
										<div className="shared_users">
											{sharedUsersState.map((user) => (
												<div key={user.SHAREWITH_USRID} className="shared_user">
													<div className="fl_l mr_2 cr_p" onClick={(e) => setUsrShare(e, user.SHAREWITH_USRID)}>
														<button type="button" className={`button check ${parseInt(sharedUsersStateChck[user.SHAREWITH_USRID]) === 1 ? 'green' : ''} fl_l mr_05`}>&nbsp;</button>
														<span className="fl_l mt_02">{user.USRNAME}</span>
													</div>
													<div className="zero h1" />
												</div>
											))}
										</div>
									)}
									<div className="zero h1" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={loading} />
									<button
										type="button"
										className="button"
										onClick={() => {
											closeNew();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
